import { TeamOutlined } from "@ant-design/icons";
import "./styles/heroIcon.css";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "Features/Routes/routeConstants";

export const HeroIcon = () => {
  const navigate = useNavigate();
  return (
    <div className="hero-icon-container">
      <TeamOutlined
        style={{ fontSize: "2em" }}
        onClick={() => navigate(ROUTES.CHAT_BOT)}
      />
    </div>
  );
};
